import { createAction, props } from '@ngrx/store';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { BookingAction, BookingStatus } from 'src/app/public/rent/constants/rent-basic-data';
import { BookingModif } from 'src/app/public/rent/models/booking-modif.model';
import { Booking } from 'src/app/public/rent/models/booking.model';


export class RentActions {

    // Bookings 

    public static bookingNewSubmit = createAction(
        '[Car Component] booking New Submit',
        props <{ booking: Booking, objectSource: ObjectSource  }> ()
    );

    // public static bookingNewSuccess = createAction(
    //     '[Car Component] booking New Success',
    //     props <{ booking: Booking }> ()
    // );

    /*
    public static bookingUpdateSubmit = createAction(
        '[Car Component] booking Update Submit',
        props <{ booking: Booking, objectSource: ObjectSource  }> ()
    );
    */

    public static bookingActionSubmit = createAction(
        '[Car Component] booking Action Submit',
        props <{ bookingAction: BookingAction, booking: Booking | BookingModif, objectSource: ObjectSource }> ()
    );

    public static bookingUpsertSuccess = createAction(
        '[Car Component] booking Update Success',
        props <{ booking: Booking, objectSource: ObjectSource  }> ()
    );

    public static bookingStatusUpdateSubmit = createAction(
        '[Car API] Update booking status submit',
        props <{ bookingId: number, status: BookingStatus, objectSource: ObjectSource  }> ()
    );

    // public static bookingStatusUpdateSuccess = createAction(
    //     '[Car API] Update booking status success',
    //     props <{ updatedBooking: Booking }> ()
    // );

}

